<template>
  <div>

    <van-nav-bar
      :title="list.name"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />

    <div class="index-body" >
      <van-cell-group title="设备基础信息">
        <van-cell title="所属项目" :value="list.project_name" />
        <van-cell title="地址" :value="list.address" />
      </van-cell-group>
      <van-cell-group>
        <van-cell title="遥测站地址" :value="list.station_address" />
        <van-cell title="经度" :value="list.longitude" />
        <van-cell title="纬度" :value="list.latitude" />
      </van-cell-group>
<!--      <van-cell-group>
        <van-cell title="预设水深报警值" :value="list.deep_police" />
        <van-cell title="预设流量报警值" :value="list.flow_police" />
      </van-cell-group>-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "DeviceMessagePage",
  data() {
    return {
      list: [],
      station_address:null,
    };
  },
  created() {
    let station_address = this.$Request.station_address;
    this.getInstrumentData(station_address)
  },
  methods: {
    getInstrumentData(station_address) {
      var that=this
      let dataInfo = {
        station_address: station_address
      };
      axios({
        method: 'post',
        url: 'monitor/report_data',
        data: dataInfo
      }).then(function (response) {
        if (response.data.code == 1) {
          that.list = response.data.data
        } else {
          that.list = null
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    bbb(){
      let station_address = this.$Request.station_address;
      this.$router.push('/DeviceDetailsPage?station_address='+station_address);
    },
    onClickLeft() {
      let station_address = this.$Request.station_address;
      this.$router.push('/Index?station_address=' + station_address);
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/DeviceMessagePage.vue